{
  "dialog": {
    "confirm": "Confirm",
    "close": "Close"
  }
}
